import { c as _c } from "react/compiler-runtime";
import type { transformCreditCardsMultiCompareEntities } from '@cc-shopping/structured-content-renderer/hydration/CreditCardsMultiCompare/transform';
import React, { type FC, type PropsWithChildren, type RefObject } from 'react';
type CreditCardsMultiCompareContextType = {
  offers: ReturnType<typeof transformCreditCardsMultiCompareEntities>;
  disableMonetization: boolean;
  containerRef?: RefObject<HTMLDivElement | null>;
};
const CreditCardsMultiCompareContext = React.createContext<CreditCardsMultiCompareContextType>({} as CreditCardsMultiCompareContextType);
const CreditCardsMultiCompareProvider: FC<PropsWithChildren<CreditCardsMultiCompareContextType>> = t0 => {
  const $ = _c(7);
  const {
    containerRef,
    children,
    offers,
    disableMonetization
  } = t0;
  let t1;
  if ($[0] !== containerRef || $[1] !== disableMonetization || $[2] !== offers) {
    t1 = {
      offers,
      containerRef,
      disableMonetization
    };
    $[0] = containerRef;
    $[1] = disableMonetization;
    $[2] = offers;
    $[3] = t1;
  } else {
    t1 = $[3];
  }
  let t2;
  if ($[4] !== children || $[5] !== t1) {
    t2 = <CreditCardsMultiCompareContext.Provider value={t1}>{children}</CreditCardsMultiCompareContext.Provider>;
    $[4] = children;
    $[5] = t1;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  return t2;
};
const useCreditCardsMultiCompareContext = () => {
  const context = React.useContext(CreditCardsMultiCompareContext);
  if (context === undefined) {
    throw new Error("useCreditCardsMultiCompareContext must be used within a CreditCardsMultiCompareProvider");
  }
  return context;
};
export { CreditCardsMultiCompareProvider, useCreditCardsMultiCompareContext };